import { GrillAssistanceInfo } from '@components/Product/Details/_GrillAssistanceInfo';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { LinkProps } from '@repo/ui/src/types/link';
import DocumentIcon from '@repo/ui/src/components/Icons/DocumentIcon';
import { classNames } from '@repo/ui/src/utils/classNames';
import InformationIcon from '@repo/ui/src/components/Icons/InformationIcon';
import Markdown from '@repo/ui/src/components/Markdown';

export interface AdditionalInformationProps {
  ownerManual?: {
    ownerManualLink: Array<LinkProps>;
  };
  prop65?: {
    title: string;
    warningBody: string;
  };
  onAnimFinishedInfoAccordion?: () => void;
  showGrillAssistanceInfo?: boolean;
  dark?: boolean;
}

const AdditionalInformation = ({
  ownerManual,
  prop65,
  showGrillAssistanceInfo = false,
  dark = false,
}: AdditionalInformationProps) => {
  if (!showGrillAssistanceInfo && !prop65 && !ownerManual?.ownerManualLink?.length) return null;

  return (
    <div
      className={classNames(
        'tra-text-body-2 tw-grid tw-gap-y-4 md:tw-gap-y-6 tw-p-4 md:tw-p-6',
        dark ? 'tw-bg-neutral-600 tw-text-white' : 'tw-bg-warm-200',
      )}
    >
      {showGrillAssistanceInfo && <GrillAssistanceInfo />}
      {prop65 && (
        <div className="tw-gap-x-2 tw-flex tw-items-baseline">
          <span>
            <InformationIcon />
          </span>

          <Markdown
            className={classNames(
              'tra-text-web-body-xl !tw-mb-0',
              dark ? 'tw-text-white' : 'tw-bg-warm-200',
            )}
          >
            {prop65.warningBody}
          </Markdown>
        </div>
      )}
      {ownerManual?.ownerManualLink?.length && prop65 && (
        <hr className={dark ? 'tw-border-neutral-500' : 'tw-border-warm-100'} />
      )}
      {ownerManual?.ownerManualLink?.length && (
        <div className="tw-flex tw-items-baseline tw-gap-x-2">
          <span className="tw-w-6">
            <DocumentIcon role="presentation" />
          </span>
          <Anchor
            {...ownerManual?.ownerManualLink[0]}
            isExternal={!!ownerManual?.ownerManualLink[0]?.externalLink}
          />
        </div>
      )}
    </div>
  );
};

export default AdditionalInformation;
